import { Grid, Typography, createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    assaMobileText: {
      fontSize: 15,
      fontWeight: 500,
    },
  }),
);

const AssaMobile = (): JSX.Element => {
  const classes = useStyles();
  return (
    <Grid
      item
      container
      alignItems="center"
      justifyContent="space-between"
      style={{ gap: '1rem', marginTop: '1rem' }}
    >
      <Typography className={classes.assaMobileText}>
        Asistencia vial
      </Typography>
      <img src="/svg/assa_movil.svg" alt="assa_movil" width={100} />
    </Grid>
  );
};

export default AssaMobile;
